import $ from 'jquery';

import { formValidator } from '../utils/form-validator';

const contactUs = () => {

  const init = () => {
    const form = $('[data-js=contact-us-form]');

    if (form.length) {
      ModifiedInnovates2018Logic();
    }
  }

  return {
    init
  }
}

export default contactUs;



function ModifiedInnovates2018Logic() {
  let $ContactUsName = $('#txtContactUsName');
  let $Organization = $('#txtOrganization');
  let $Email = $('#txtEmail');
  let $Phone = $('#txtPhone');
  let $Subject = $('#ddlSubject');
  let $Message = $('#txtMessage');
  let $captcha = $('#grecaptcha');
  fieldfocusOut();

  const loader = createLoader(); /* For showing loading state */

  $('#btnSubmit').click(function () {

      if (validForm()) {

          SaveData();
      }
      else {
          const el = $('.field-validation-error:first');
          if (el) {
              $('html,body').animate({ scrollTop: (el.offset().top - 100) }, 'slow', () => {
                  el.focus();
              });
          }
      }
  });

  $('#btnReset').click(function () {

      clearform();
  });

  var isFormValid = true;
  var grecaptchaWidget = "";

  function SaveData() {

    var language = document.documentElement.lang;
    loader.enable();
    var url = location.pathname + "/SaveContactUs";

    $.ajax({
        type: 'Post',
        url: url,
        data: {

            'Name': $ContactUsName.val(), 'Email': $Email.val(), 'Phone': $Phone.val(), 'Organization': $Organization.val(),
            'Subject': $('#ddlSubject :selected').text(), 'Message': $Message.val(), 'SubjectValue': $Subject.val(), 'Culture': language,
            'captcha': grecaptcha.getResponse()
        },
        cache: false,
        error: function (data) {
            console.log(data);
            //var language = document.documentElement.lang;
            var errorMessage = language == "en" ? "Error Occured!" : "حدث خطأ!";
            $('div#showMessage').html("<div class='alert alert-danger' role='alert'>" + errorMessage + "</div>");
        },

        success: function (data) {

            if (data.ResponseCode == 0 || data.ResponseCode == 1 || data.ResponseCode == 3) {

                var message = data.ResponseMessage;
                $('div#showMessage').html("<div class='alert alert-danger' role='alert'>" + message + "</div>");
            }

            else if (data.ResponseCode == 2) {
                var message = language == "en" ? "Form has been submitted successfully" : "تم التقديم بنجاح";
                $('div#showMessage').html("<div class='alert alert-success' role='alert'>" + message + "</div>");
            }
        },

        complete: function () {
            loader.disable();
            $('#showMessage').fadeOut(10000, "linear", function () {
                $("div#showMessage").html("");
                $("div#showMessage").removeAttr("style");
            });

            clearform();


        }
    });

  }

  function validForm() {

    isFormValid = true;

    validatestringField($ContactUsName, "name", "Name is not valid.", "الأسم الذي أدخلتة غير صحيح");
    validateEmailField($Email, "email");
    validateContactNo($Phone, "phone");
    validatestringField($Organization, "organization", "Organization name is not valid.", "إسم المؤسسة غير صحيح");
    validateDropDownField($Subject, "subject");
    validateMessageField($Message, "message");
    validateCaptcha($captcha, "captcha");
    return isFormValid;
  }

  function vlidateRequiredField(element, id) {

    formValidator.clearOneErrorMessage(id);

    var value = element.val();

    var message = formValidator.getLanguage() === "en" ? "You can’t leave this blank" : "لا يمكنك ترك هذا الحقل فارغا";

    if (formValidator.isEmpty(value)) {

        formValidator.setErrorMessage(element, message, id);
        isFormValid = false;
        return false;
    }

    return true;
  }

  function validateContactNo(element, id) {
    if (vlidateRequiredField(element, id)) {

        var value = element.val();

        if (!formValidator.validateConatctNo(value)) {

            var message = formValidator.getLanguage() === "en" ? "Contact number is not valid" : "رقم التواصل الذي أدخلته غير صحيح";

            formValidator.setErrorMessage(element, message, id);

            isFormValid = false;
        }
    }
  }

  function validatestringField(element, id, enText, arText) {

    if (vlidateRequiredField(element, id)) {

        var value = element.val();

        if (!formValidator.validateStringField(value)) {

            var message = formValidator.getLanguage() === "en" ? enText : arText;

            formValidator.setErrorMessage(element, message, id);

            isFormValid = false;
        }
    }

  }

  function validateDropDownField(element, id) {

    formValidator.clearOneErrorMessage(id);

    var value = element.val();

    if (value === "" || value === undefined) {

        var message = formValidator.getLanguage() === "en" ? "Please select subject" : "الرجاء أختر الموضوع";

        formValidator.setErrorMessageForCategory(element, message, id);

        isFormValid = false;
    }
  }

  function validateEmailField(element, id) {

    if (vlidateRequiredField(element, id)) {

        var value = element.val();

        if (!formValidator.validateEmailSyntax(value)) {

            var message = formValidator.getLanguage() === "en" ? "Invalid Email" : "بريد ألكترونى غير صحيح";

            formValidator.setErrorMessage(element, message, id);

            isFormValid = false;
        }
    }

  }


  function validateMessageField(element, id) {

    //formValidator.clearOneErrorMessage(id);

    if (vlidateRequiredField(element, id)) {

        var value = element.val();

        if (!formValidator.ValidTextArea(value)) {

            var message = formValidator.getLanguage() === "en" ? "Message is not in a proper format." : "الرسالة التى أدخلتها غير صحيحة";

            formValidator.setErrorMessage(element, message, id);
            isFormValid = false;
        }
    }
  }

  function fieldfocusOut() {

    $ContactUsName.on("focusout", function () {
        validatestringField($ContactUsName, "name", "Name is not valid.", "الأسم الذي أدخلتة غير صحيح");
    });

    $Organization.on("focusout", function () {
       validatestringField($Organization, "organization", "Organization name is not valid.", "");
    });


    $Email.on("focusout", function () {
        validateEmailField($Email, "email");

    });

    $Phone.on("focusout", function () {
       validateContactNo($Phone, "phone");
    });

    $Subject.on("focusout", function () {
        validateDropDownField($Subject, "subject");
    });

    $Message.on("focusout", function () {
        validateMessageField($Message, "message");
    });

    $captcha.on("focusout", function () {
        validateCaptcha($captcha, "captcha");
    });
  }


  function validateCaptcha(element, id) {

    formValidator.clearOneErrorMessage(id);

    var response = grecaptcha.getResponse();
    if (response.length == 0) {

        var message = formValidator.getLanguage() === "en" ? "You can’t leave this blank" : "لا يمكنك ترك هذا الحقل فارغا";
        formValidator.setErrorMessage(element, message, id);
        isFormValid = false;
    }


  }

  function clearform() {
    $($ContactUsName).val('');
    $($Organization).val('');
    $($Email).val('');
    $($Phone).val('');
    $($Subject).val('');
    $($Message).val('');
    grecaptcha.reset();
    $('#name').remove();
    $('#email').remove();
    $('#phone').remove();
    $('#organization').remove();
    $('#subject').remove();
    $('#message').remove();
    $('#captcha').remove();
  }


};


function createLoader() {
  const form = $('[data-js=contact-us-form]');

  const enable = () => {
    $(form).addClass('circle-loader__parent--loading');
  }

  const disable = () => {
    setTimeout(() => {
      $(form).removeClass('circle-loader__parent--loading');
    }, 2000)
  }

  return {
    enable,
    disable
  }
}
